// composing redux bundle
import { composeBundles } from "redux-bundler";
import mealBundle from "./mealBundle";

export default composeBundles(mealBundle);
